<template>
  <div class="brd">
    <div v-for="(item, index) in items" v-bind:key="index">
      <div class="input-group mb-1" :class="[sizeVal]">
        <select class="input-group-text custom-select" v-model="items[index][0]">
          <option v-for="item in days" v-bind:key="item.value" :value="item.value">{{$t(item.text)}}</option>
        </select>
        <VueClockPicker
          v-model="items[index][1]"
          active-color="#3a3e42"
          :input-class="sizeFullVal"
          placeholder="from"
          close-on-overlay
        />
        <VueClockPicker
          v-model="items[index][2]"
          active-color="#3a3e42"
          :input-class="sizeFullVal"
          close-on-overlay
        />
        <div class="input-group-append">
          <span class="input-group-text pt" @click="deleteItem(index)" :title="deleteTootltip">x</span>
        </div>
      </div>
    </div>
    <b-button type="button" variant="brand" class="btn-sm mt-1" @click="addItem()">{{addLabel}}</b-button>
  </div>
</template>

<script>
import VueClockPicker from "../components/clock-picker";

export default {
  components: {
    VueClockPicker
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    addLabel: {
      type: String,
      required: true,
      default: () => "Add New Item"
    },
    deleteTootltip: {
      type: String,
      default: () => "Delete Item"
    },
    size: {
      type: String,
      default: ""
    }
  },
  computed: {
    sizeVal() {
      return this.size ? `input-group-${this.size}` : "";
    },
    sizeFullVal() {
      return this.size
        ? `form-control form-control-${this.size} br-none`
        : "form-control br-none";
    }
  },
  data() {
    return {
      days: [
        { value: 1, text: "Monday" },
        { value: 2, text: "Tuesday" },
        { value: 3, text: "Wednesday" },
        { value: 4, text: "Thursday" },
        { value: 5, text: "Friday" },
        { value: 6, text: "Saturday" },
        { value: 7, text: "Sunday" },
        { value: 8, text: "Monday - Friday" }
      ]
    };
  },
  methods: {
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    addItem(index) {
      this.items.push([1, "00:00", "00:00"]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
